<div
  class="app-shell"
  [class.sidebar-open]="sidebarOpen"
  [class.sidebar-expanded]="sidebarExpanded"
>
  <app-header (menuToggle)="toggleSidebar()"></app-header>

  <div class="app-shell__body">
    <div
      class="app-shell__backdrop"
      *ngIf="sidebarOpen"
      (click)="closeSidebarMobile()"
      aria-hidden="true"
    ></div>

    <aside
      class="app-shell__sidebar"
      [class.is-open]="sidebarOpen"
      [class.is-expanded]="sidebarExpanded"
      [class.is-collapsed]="!sidebarExpanded"
    >
      <app-layout-sidebar
        (navigateClose)="closeSidebarMobile()"
        (requestExpand)="expandSidebar()"
      ></app-layout-sidebar>
    </aside>

    <main class="app-shell__main" role="main">
      <div class="app-shell__content">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>

  <app-footer></app-footer>
</div>
